export default __webpack_public_path__ + "cdot-2020-short-white.png";